@if(!isEnabledGafiRedirect){
    <app-main-navbar></app-main-navbar>
    <app-welcome-component></app-welcome-component>
    <app-why-egypt></app-why-egypt>
    <app-news></app-news>
    <app-know-more></app-know-more>
    <app-carousel-home></app-carousel-home>
    <app-carousel-el-departments></app-carousel-el-departments>
    <app-operations></app-operations>
    <app-search></app-search>
    <app-success-story></app-success-story>
    <app-center-services></app-center-services>
}
